import React, { FC, useState } from 'react';
import DialogStyled from 'components/Organization/Placeholders/PlaceholderDialog/DialogStyled';
import styles from './AddQuoteModal.module.scss';
import ButtonCross from '../../../Buttons/ButtonCross';
import { IQuoteExtendedResponse } from '@joc/api-gateway/lib/api-client';
import cx from 'classnames';
import { AddQuoteTab } from './AddQuoteTab';
import { ImportQuotesTab } from './ImportQuotesTab';

interface AddQuoteModalProps {
	isModalOpen: boolean;
	onClose: () => void;
	quote?: IQuoteExtendedResponse;
}

export const AddQuoteModal: FC<AddQuoteModalProps> = ({ isModalOpen, onClose, quote }) => {
	const [selectedTab, setSelectedTab] = useState<'single' | 'multiple'>('single');

	const closeDialog = () => onClose();

	return (
		<DialogStyled open={isModalOpen} maxWidth="xl">
			<section className={styles.dialog}>
				<div className={styles.dialog__header}>
					<ButtonCross clickHandler={closeDialog} parentClassName={styles.dialog__header_button} />
				</div>

				<div className={styles.dialog__form_header}>
					<span className={styles.dialog__form_header_title}>
						{quote ? 'Edit Daily Quote' : 'Add Daily Quotes'}
					</span>

					{!quote && (
						<div className={styles.dialog__form_header_tabs}>
							<button
								className={cx(
									styles.dialog__form_header_tabs_tab,
									selectedTab === 'single' ? styles.dialog__form_header_tabs_active : ''
								)}
								onClick={() => setSelectedTab('single')}
							>
								Add Single
							</button>
							<button
								className={cx(
									styles.dialog__form_header_tabs_tab,
									selectedTab === 'multiple' ? styles.dialog__form_header_tabs_active : ''
								)}
								onClick={() => setSelectedTab('multiple')}
							>
								Add by list
							</button>
						</div>
					)}
				</div>

				{selectedTab === 'single' || quote ? (
					<AddQuoteTab quote={quote} onClose={onClose} />
				) : (
					<ImportQuotesTab isEditing={!!quote} onClose={onClose} />
				)}
			</section>
		</DialogStyled>
	);
};
